import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationOnIcon from '@mui/icons-material/LocationOnOutlined';
import {
    Box,
    Card,
    CardContent,
    Chip,
    Stack,
    Typography
} from "@mui/material";
import { getRelativeTime } from "../../../util/date";
import { getNullableString } from "../../../util/string";
import { Job } from "../types";
import JobCompanyIcon from "./JobCompanyIcon";

interface JobCardProps {
    job: Job;
    selectedJobsId: string,
    onSave: (jobId: string) => void;
    onClick: (jobId: string) => void;
}

const getCrawlerDisplay = (provider: string | undefined | null, search: string | undefined | null) => {
    return provider + (!!provider && !!search ? " - " : "") + search;
}

export const JobCard = ({ job, selectedJobsId, onSave, onClick }: JobCardProps) => (
    <Card
        sx={{
            m: .5,
            position: 'relative',
            "&:hover": { cursor: 'pointer' },
            border: selectedJobsId === job._id ? theme => `1px solid ${theme.palette.primary.main}` : "1px solid #00000000",
            boxShadow: selectedJobsId === job._id
                ? theme => `0 0 2px 0 ${theme.palette.primary.main}`
                : "none",
        }}
        onClick={() => onClick(job._id)}
    >
        <CardContent >
            <Stack direction="row" gap={1} justifyContent="space-between" alignItems="top">
                <JobCompanyIcon job={job} />
                <Box >
                    {job.fromCrawlerSearch &&
                        <Chip label={getCrawlerDisplay(job.fromCrawlerProvider, job.fromCrawlerSearch)} color="primary" sx={{ fontSize: "12px" }} />}
                </Box>
            </Stack>

            <Stack gap={2} overflow="hidden" mt={2}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack gap={1}>
                        <Typography variant="subtitle1" component="div">
                            {job.title}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="text.secondary"
                        >
                            {getNullableString(job.company)}
                        </Typography>
                    </Stack>
                    {/* 
                    <IconButton
                        sx={{ position: 'absolute', top: 10, right: 10 }}
                        onClick={() => onSave(job._id)}
                    >
                        <BookmarkBorderIcon />
                    </IconButton> */}
                </Stack>

                <Stack gap={1}>
                    <Stack direction="row" gap={1}>
                        <LocationOnIcon fontSize="inherit" sx={{ color: 'text.secondary' }} />
                        <Stack direction="row" gap={.5} >
                            <Chip label={getNullableString(job.location)} size="small" sx={{ height: 1, fontSize: "12px" }} />
                        </Stack>
                    </Stack>

                    <Stack direction="row" gap={1}>
                        <LocationOnIcon fontSize="inherit" sx={{ color: 'text.secondary' }} />
                        <Stack direction="row" gap={.5} >
                            <Chip label={getNullableString(job.category)} size="small" sx={{ height: 1, fontSize: "12px" }} />
                        </Stack>
                    </Stack>
                </Stack>

                {/* <CustomMDPreview description={getBriefDescription(job.description)} /> */}
            </Stack>
            <Stack direction="row" alignItems="center" gap={1} mt={2}>
                <AccessTimeIcon fontSize="small" />
                <Typography variant="body2" color="text.secondary">
                    {job.createdAt ? getRelativeTime(job.createdAt) : "Recently"}
                </Typography>
            </Stack>
        </CardContent >
    </Card >
); 